<app-intro-tab-paragraph headerTitle="Our philosophy" text="{{ introP }}"></app-intro-tab-paragraph>
<div class="videoWrapper">
    <iframe src="https://www.youtube.com/embed/FHXDlkJzAIA" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>